import { memo } from "react";
import { useNavigate } from "react-router-dom";

import "./ifError.scss";

const IfError = (object) => {
  const navigate = useNavigate();
  function modalConsultaIRPF() {
    return (
      <>
        <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column p-5">
          {object.mensage}
          <div className="gridBotones mb-2 d-flex justify-content-center">
              <button
                id="volver"
                className="btnRed rounded btnCancelarDocumentacion"
                type="button"
                onClick={() => {
                  navigate(object.ruta)
                }}
              >
                Vuelve a iniciar sesión
              </button>
            </div>
        </div>
      </>
    );
  }

  return <>{modalConsultaIRPF()}</>;
};

export default memo(IfError);
